import { LocalTaskProviderData } from "@jelly/lesson";

import lesson01 from "../../lesson/course-05/lesson-01/lesson";
import lesson02 from "../../lesson/course-05/lesson-02/lesson";
import lesson03 from "../../lesson/course-05/lesson-03/lesson";
import lesson04 from "../../lesson/course-05/lesson-04/lesson";
import lesson05 from "../../lesson/course-05/lesson-05/lesson";
import lesson06 from "../../lesson/course-05/lesson-06/lesson";
import lesson07 from "../../lesson/course-05/lesson-07/lesson";
import lesson09 from "../../lesson/course-05/lesson-09/lesson";
import lesson10 from "../../lesson/course-05/lesson-10/lesson";
import lesson11 from "../../lesson/course-05/lesson-11/lesson";
import lesson12 from "../../lesson/course-05/lesson-12/lesson";
import lesson13 from "../../lesson/course-05/lesson-13/lesson";
import lesson14 from "../../lesson/course-05/lesson-14/lesson";
import lesson15 from "../../lesson/course-05/lesson-15/lesson";
import lesson16 from "../../lesson/course-05/lesson-16/lesson";
import lesson25 from "../../lesson/course-05/lesson-25/lesson";
import lesson21 from "../../lesson/course-05/lesson-21/lesson";
import lesson20 from "../../lesson/course-05/lesson-20/lesson";
import lesson19 from "../../lesson/course-05/lesson-19/lesson";
import lesson17 from "../../lesson/course-05/lesson-17/lesson";
import lesson18 from "../../lesson/course-05/lesson-18/lesson";
import lesson22 from "../../lesson/course-05/lesson-22/lesson";
import lesson23 from "../../lesson/course-05/lesson-23/lesson";
import lesson24 from "../../lesson/course-05/lesson-24/lesson";
import lesson26 from "../../lesson/course-05/lesson-26/lesson";
import lesson27 from "../../lesson/course-05/lesson-27/lesson";
import lesson28 from "../../lesson/course-05/lesson-28/lesson";
import lesson29 from "../../lesson/course-05/lesson-29/lesson";
import lesson08 from "../../lesson/course-05/lesson-08/lesson";
import lesson30 from "../../lesson/course-05/lesson-30/lesson";
import * as task0101 from "./lesson-01/task-01";
import * as task0102 from "./lesson-01/task-02";
import * as task0201 from "./lesson-02/task-01";
import * as task0202 from "./lesson-02/task-02";
import * as task0301 from "./lesson-03/task-01";
import * as task0401 from "./lesson-04/task-01";
import * as task0501 from "./lesson-05/task-01";
import * as task0601 from "./lesson-06/task-01";
import * as task0602 from "./lesson-06/task-02";
import * as task0603 from "./lesson-06/task-03";
import * as task0604 from "./lesson-06/task-04";
import * as task0605 from "./lesson-06/task-05";
import * as task0606 from "./lesson-06/task-06";
import * as task0607 from "./lesson-06/task-07";
import * as task0801 from "./lesson-08/task-01";
import * as task0701 from "./lesson-07/task-01";
import * as task0702 from "./lesson-07/task-02";
import * as task0703 from "./lesson-07/task-03";
import * as task0704 from "./lesson-07/task-04";
import * as task0901 from "./lesson-09/task-01";
import * as task1001 from "./lesson-10/task-01";
import * as task1002 from "./lesson-10/task-02";
import * as task1003 from "./lesson-10/task-03";
import * as task1101 from "./lesson-11/task-01";
import * as task1102 from "./lesson-11/task-02";
import * as task1103 from "./lesson-11/task-03";
import * as task1104 from "./lesson-11/task-04";
import * as task1201 from "./lesson-12/task-01";
import * as task1202 from "./lesson-12/task-02";
import * as task1203 from "./lesson-12/task-03";
import * as task1204 from "./lesson-12/task-04";
import * as task1301 from "./lesson-13/task-01";
import * as task1401 from "./lesson-14/task-01";
import * as task1501 from "./lesson-15/task-01";
import * as task1601 from "./lesson-16/task-01";
import * as task2501 from "./lesson-25/task-01";
import * as task2101 from "./lesson-21/task-01";
import * as task2102 from "./lesson-21/task-02";
import * as task2103 from "./lesson-21/task-03";
import * as task2001 from "./lesson-20/task-01";
import * as task1901 from "./lesson-19/task-01";
import * as task1902 from "./lesson-19/task-02";
import * as task1903 from "./lesson-19/task-03";
import * as task1701 from "./lesson-17/task-01";
import * as task1702 from "./lesson-17/task-02";
import * as task1703 from "./lesson-17/task-03";
import * as task1704 from "./lesson-17/task-04";
import * as task1705 from "./lesson-17/task-05";
import * as task1706 from "./lesson-17/task-06";
import * as task1801 from "./lesson-18/task-01";
import * as task1802 from "./lesson-18/task-02";
import * as task1803 from "./lesson-18/task-03";
import * as task1804 from "./lesson-18/task-04";
import * as task2201 from "./lesson-22/task-01";
import * as task2202 from "./lesson-22/task-02";
import * as task2203 from "./lesson-22/task-03";
import * as task2204 from "./lesson-22/task-04";
import * as task2205 from "./lesson-22/task-05";
import * as task2301 from "./lesson-23/task-01";
import * as task2302 from "./lesson-23/task-02";
import * as task2303 from "./lesson-23/task-03";
import * as task2304 from "./lesson-23/task-04";
import * as task2401 from "./lesson-24/task-01";
import * as task2601 from "./lesson-26/task-01";
import * as task2701 from "./lesson-27/task-01";
import * as task2801 from "./lesson-28/task-01";
import * as task2802 from "./lesson-28/task-02";
import * as task2901 from "./lesson-29/task-01";
import * as task2902 from "./lesson-29/task-02";
import * as task2903 from "./lesson-29/task-03";
import * as task3001 from "./lesson-30/task-01";

const data: LocalTaskProviderData = {
  byId: {
    [task0101.task.id]: task0101.task,
    [task0102.task.id]: task0102.task,
    [task0201.task.id]: task0201.task,
    [task0202.task.id]: task0202.task,
    [task0301.task.id]: task0301.task,
    [task0401.task.id]: task0401.task,
    [task0501.task.id]: task0501.task,
    [task0601.task.id]: task0601.task,
    [task0602.task.id]: task0602.task,
    [task0603.task.id]: task0603.task,
    [task0604.task.id]: task0604.task,
    [task0605.task.id]: task0605.task,
    [task0606.task.id]: task0606.task,
    [task0607.task.id]: task0607.task,
    [task0801.task.id]: task0801.task,
    [task0701.task.id]: task0701.task,
    [task0702.task.id]: task0702.task,
    [task0703.task.id]: task0703.task,
    [task0704.task.id]: task0704.task,
    [task0901.task.id]: task0901.task,
    [task1001.task.id]: task1001.task,
    [task1002.task.id]: task1002.task,
    [task1003.task.id]: task1003.task,
    [task1101.task.id]: task1101.task,
    [task1102.task.id]: task1102.task,
    [task1103.task.id]: task1103.task,
    [task1104.task.id]: task1104.task,
    [task1201.task.id]: task1201.task,
    [task1202.task.id]: task1202.task,
    [task1203.task.id]: task1203.task,
    [task1204.task.id]: task1204.task,
    [task1301.task.id]: task1301.task,
    [task1401.task.id]: task1401.task,
    [task1501.task.id]: task1501.task,
    [task1601.task.id]: task1601.task,
    [task2501.task.id]: task2501.task,
    [task2101.task.id]: task2101.task,
    [task2102.task.id]: task2102.task,
    [task2103.task.id]: task2103.task,
    [task2001.task.id]: task2001.task,
    [task1901.task.id]: task1901.task,
    [task1902.task.id]: task1902.task,
    [task1903.task.id]: task1903.task,
    [task1701.task.id]: task1701.task,
    [task1702.task.id]: task1702.task,
    [task1703.task.id]: task1703.task,
    [task1704.task.id]: task1704.task,
    [task1705.task.id]: task1705.task,
    [task1706.task.id]: task1706.task,
    [task1801.task.id]: task1801.task,
    [task1802.task.id]: task1802.task,
    [task1803.task.id]: task1803.task,
    [task1804.task.id]: task1804.task,
    [task2201.task.id]: task2201.task,
    [task2202.task.id]: task2202.task,
    [task2203.task.id]: task2203.task,
    [task2204.task.id]: task2204.task,
    [task2205.task.id]: task2205.task,
    [task2301.task.id]: task2301.task,
    [task2302.task.id]: task2302.task,
    [task2303.task.id]: task2303.task,
    [task2304.task.id]: task2304.task,
    [task2401.task.id]: task2401.task,
    [task2601.task.id]: task2601.task,
    [task2701.task.id]: task2701.task,
    [task2801.task.id]: task2801.task,
    [task2802.task.id]: task2802.task,
    [task2901.task.id]: task2901.task,
    [task2902.task.id]: task2902.task,
    [task2903.task.id]: task2903.task,
    [task3001.task.id]: task3001.task,
  },
  byLessonId: {
    [lesson01.id]: [task0101.task, task0102.task],
    [lesson02.id]: [task0201.task, task0202.task],
    [lesson03.id]: [task0301.task],
    [lesson04.id]: [task0401.task],
    [lesson05.id]: [task0501.task],
    [lesson06.id]: [
      task0601.task,
      task0602.task,
      task0603.task,
      task0604.task,
      task0605.task,
      task0606.task,
      task0607.task,
    ],
    [lesson07.id]: [task0701.task, task0702.task, task0703.task, task0704.task],
    [lesson08.id]: [task0801.task],
    [lesson09.id]: [task0901.task],
    [lesson10.id]: [task1001.task, task1002.task, task1003.task],
    [lesson11.id]: [task1101.task, task1102.task, task1103.task, task1104.task],
    [lesson12.id]: [task1201.task, task1202.task, task1203.task, task1204.task],
    [lesson13.id]: [task1301.task],
    [lesson14.id]: [task1401.task],
    [lesson15.id]: [task1501.task],
    [lesson16.id]: [task1601.task],
    [lesson25.id]: [task2501.task],
    [lesson21.id]: [task2101.task, task2102.task, task2103.task],
    [lesson20.id]: [task2001.task],
    [lesson19.id]: [task1901.task, task1902.task, task1903.task],
    [lesson18.id]: [task1801.task, task1802.task, task1803.task, task1804.task],
    [lesson17.id]: [task1701.task, task1702.task, task1703.task, task1704.task, task1705.task, task1706.task],
    [lesson22.id]: [task2201.task, task2202.task, task2203.task, task2204.task, task2205.task],
    [lesson23.id]: [task2301.task, task2302.task, task2303.task, task2304.task],
    [lesson24.id]: [task2401.task],
    [lesson26.id]: [task2601.task],
    [lesson27.id]: [task2701.task],
    [lesson28.id]: [task2801.task, task2802.task],
    [lesson29.id]: [task2901.task, task2902.task, task2903.task],
    [lesson30.id]: [task3001.task],
  },
  expectedAnswerMetadata: {
    [task0101.task.id]: task0101.expectedAnswerMetadata,
    [task0102.task.id]: task0102.expectedAnswerMetadata,
    [task0201.task.id]: task0201.expectedAnswerMetadata,
    [task0202.task.id]: task0202.expectedAnswerMetadata,
    [task0301.task.id]: task0301.expectedAnswerMetadata,
    [task0401.task.id]: task0401.expectedAnswerMetadata,
    [task0501.task.id]: task0501.expectedAnswerMetadata,
    [task0601.task.id]: task0601.expectedAnswerMetadata,
    [task0602.task.id]: task0602.expectedAnswerMetadata,
    [task0603.task.id]: task0603.expectedAnswerMetadata,
    [task0604.task.id]: task0604.expectedAnswerMetadata,
    [task0605.task.id]: task0605.expectedAnswerMetadata,
    [task0606.task.id]: task0606.expectedAnswerMetadata,
    [task0607.task.id]: task0607.expectedAnswerMetadata,
    [task0701.task.id]: task0701.expectedAnswerMetadata,
    [task0702.task.id]: task0702.expectedAnswerMetadata,
    [task0703.task.id]: task0703.expectedAnswerMetadata,
    [task0704.task.id]: task0704.expectedAnswerMetadata,
    [task0801.task.id]: task0801.expectedAnswerMetadata,
    [task0901.task.id]: task0901.expectedAnswerMetadata,
    [task1001.task.id]: task1001.expectedAnswerMetadata,
    [task1002.task.id]: task1002.expectedAnswerMetadata,
    [task1003.task.id]: task1003.expectedAnswerMetadata,
    [task1101.task.id]: task1101.expectedAnswerMetadata,
    [task1102.task.id]: task1102.expectedAnswerMetadata,
    [task1103.task.id]: task1103.expectedAnswerMetadata,
    [task1104.task.id]: task1104.expectedAnswerMetadata,
    [task1201.task.id]: task1201.expectedAnswerMetadata,
    [task1202.task.id]: task1202.expectedAnswerMetadata,
    [task1203.task.id]: task1203.expectedAnswerMetadata,
    [task1204.task.id]: task1204.expectedAnswerMetadata,
    [task1301.task.id]: task1301.expectedAnswerMetadata,
    [task1401.task.id]: task1401.expectedAnswerMetadata,
    [task1501.task.id]: task1501.expectedAnswerMetadata,
    [task1601.task.id]: task1601.expectedAnswerMetadata,
    [task2301.task.id]: task2301.expectedAnswerMetadata,
    [task2302.task.id]: task2302.expectedAnswerMetadata,
    [task2303.task.id]: task2303.expectedAnswerMetadata,
    [task2304.task.id]: task2304.expectedAnswerMetadata,
    [task2501.task.id]: task2501.expectedAnswerMetadata,
    [task2101.task.id]: task2101.expectedAnswerMetadata,
    [task2102.task.id]: task2102.expectedAnswerMetadata,
    [task2103.task.id]: task2103.expectedAnswerMetadata,
    [task2001.task.id]: task2001.expectedAnswerMetadata,
    [task1901.task.id]: task1901.expectedAnswerMetadata,
    [task1902.task.id]: task1902.expectedAnswerMetadata,
    [task1903.task.id]: task1903.expectedAnswerMetadata,
    [task1801.task.id]: task1801.expectedAnswerMetadata,
    [task1802.task.id]: task1802.expectedAnswerMetadata,
    [task1803.task.id]: task1803.expectedAnswerMetadata,
    [task1804.task.id]: task1804.expectedAnswerMetadata,
    [task1701.task.id]: task1701.expectedAnswerMetadata,
    [task1702.task.id]: task1702.expectedAnswerMetadata,
    [task1703.task.id]: task1703.expectedAnswerMetadata,
    [task1704.task.id]: task1704.expectedAnswerMetadata,
    [task1705.task.id]: task1705.expectedAnswerMetadata,
    [task1706.task.id]: task1706.expectedAnswerMetadata,
    [task2401.task.id]: task2401.expectedAnswerMetadata,
    [task2601.task.id]: task2601.expectedAnswerMetadata,
    [task2701.task.id]: task2701.expectedAnswerMetadata,
    [task2801.task.id]: task2801.expectedAnswerMetadata,
    [task2802.task.id]: task2802.expectedAnswerMetadata,
    [task2901.task.id]: task2901.expectedAnswerMetadata,
    [task2902.task.id]: task2902.expectedAnswerMetadata,
    [task2903.task.id]: task2903.expectedAnswerMetadata,
    [task2201.task.id]: task2201.expectedAnswerMetadata,
    [task2202.task.id]: task2202.expectedAnswerMetadata,
    [task2203.task.id]: task2203.expectedAnswerMetadata,
    [task2204.task.id]: task2204.expectedAnswerMetadata,
    [task2205.task.id]: task2205.expectedAnswerMetadata,
    [task3001.task.id]: task3001.expectedAnswerMetadata,
  },
};

export default data;
